import { Competension } from './Competension';

export default Competension;